import React, { useEffect } from 'react';
import { Box, Text } from '@chakra-ui/react';
import Success from 'icons/images/success';
import { useSession } from 'context/SessionContext';

const SuccessPage: React.FC = () => {
  const { setData } = useSession();

  useEffect(() => {
    setData({});
    sessionStorage.clear(); 
  }, []);

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      minH="calc(100vh - 100px)"
      textAlign="center"
      p="0 10px"
    >
      <Success />
      <Text as="h1" fontSize={["30px", "40px"]} mb={6} color="brand.primary">
        O seu questionário foi enviado com sucesso.
      </Text>
      <Text fontSize="16px" color="brand.fontColors.primary">
        Pode fechar a página. Entraremos em contacto caso seja necessária informação adicional.
      </Text>
    </Box>
  );
};

export default SuccessPage;
